// const AJAX_URL = '/wp-admin/admin-ajax.php'

jQuery(document).foundation();
jQuery(document).ready(function($) {
  // joints_wp_fixes();
  // AOS.init()  //Enable if loading AOS

  var section = document.querySelector(".vs-section");
  // var divs = document.querySelectorAll('.vs-transform');

  var smooth = new Smooth({
    direction: "vertical",
    section: section,
    ease: 0.1,
    native: true
    // els: divs
  });

  smooth.init();

  $(window).resize(function() {
    smooth.resize();
  });

  smooth.scrollTo(0);

  var win = $(window);
  var allReverseBorder = $(".reverse-box");

  win.scroll(function(event) {
    allReverseBorder.each(function(i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("animate");
      }
    });
  });

  //VIDEO LazyLoad
  var lazyVideos = [].slice.call(document.querySelectorAll("iframe.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(
      entries,
      observer
    ) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          video.target.src = video.target.dataset.src;
          // video.target.reload();
          video.target.onload = function() {
            video.target.classList.add('loaded');
          };
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }

  // $('.off-canvas-wrapper:contains("CF + D")').contents().each(function () {
  //   if (this.nodeType == 1) { //Look for only element Nodes
  //     $(this).html(function (_, oldValue) {
  //         return oldValue.replace(/CF\s\+\sD/g, "<span class='nowrap'>CF + D</span>")
  //     })
  //   }
  // });

  if ($(".jobs-scroll").length > 0) {
    $(".jobs-scroll").on("click", function() {
      var div = document.querySelector("#jobs");
      var offset = div.offsetTop;
      smooth.scrollTo(offset);
    });
  }

  if ($(".apply-scroll").length > 0) {
    $(".apply-scroll").on("click", function() {
      var div = document.querySelector("#apply");
      var offset = div.offsetTop;
      smooth.scrollTo(offset);
    });
  }

  if ($(".get-started-scroll").length > 0) {
    $(".get-started-scroll").on("click", function() {
      var div = document.querySelector("#get-started");
      var offset = div.offsetTop;
      smooth.scrollTo(offset);
    });
  }

  if ($(".gform_button_select_files").length > 0) {
    $(".gform_button_select_files").prop("value", "Browse");
  }

  //SLIDER
  if ($(".video-slider").length > 0) {
    let sliderElem = document.querySelector(".video-sections");
    let indicatorElem = document.querySelector(".video__slider__indicator");
    let indicatorButton = document.querySelector(
      ".video__slider__indicator__button"
    );

    $(".video__slider__button").click(function(el) {
      el.preventDefault();

      let currentPos = parseInt(sliderElem.getAttribute("data-pos"), 10);
      let newPos = parseInt(el.target.getAttribute("data-pos"), 10);

      let newDirection = newPos > currentPos ? "right" : "left";
      let currentDirection = newPos < currentPos ? "right" : "left";

      indicatorButton.classList.remove(
        `video__slider__indicator--${currentDirection}`
      );
      indicatorButton.classList.add(
        `video__slider__indicator--${newDirection}`
      );
      sliderElem.setAttribute("data-pos", newPos);
    });

    $(".video__slider__dot").click(function(el) {
      el.preventDefault();

      let currentPos = parseInt(sliderElem.getAttribute("data-pos"));
      let newPos = parseInt(el.target.getAttribute("data-pos"));

      let newDirection = newPos > currentPos ? "right" : "left";
      let currentDirection = newPos < currentPos ? "right" : "left";

      indicatorElem.classList.remove(
        `video__slider__indicator--${currentDirection}`
      );
      indicatorElem.classList.add(`video__slider__indicator--${newDirection}`);
      sliderElem.setAttribute("data-pos", newPos);
    });
  }
  if ($(".product-slider").length > 0) {
    let sliderElem = document.querySelector(".product-slider");
    // let indicatorElem = document.querySelector(".slider__indicator");

    // $(".slider__dot").click(function(el) {
    //   el.preventDefault();

    //   let currentPos = parseInt(sliderElem.getAttribute("data-pos"));
    //   let newPos = parseInt(el.target.getAttribute("data-pos"));

    //   let newDirection = newPos > currentPos ? "right" : "left";
    //   let currentDirection = newPos < currentPos ? "right" : "left";

    //   indicatorElem.classList.remove(`slider__indicator--${currentDirection}`);
    //   indicatorElem.classList.add(`slider__indicator--${newDirection}`);
    //   sliderElem.setAttribute("data-pos", newPos);
    // });
    var totalSlides = $(".background").length;
    let newPos = 0;

    $(".vertical-next").click(function(el) {
      el.preventDefault();

      let currentPos = parseInt(sliderElem.getAttribute("data-pos"));

      if (currentPos < totalSlides - 1) {
        newPos = currentPos + 1;
      }

      // let newDirection = newPos > currentPos ? "right" : "left";
      // let currentDirection = newPos < currentPos ? "right" : "left";

      // indicatorElem.classList.remove(`slider__indicator--${currentDirection}`);
      // indicatorElem.classList.add(`slider__indicator--${newDirection}`);
      sliderElem.setAttribute("data-pos", newPos);
    });

    $(".vertical-prev").click(function(el) {
      el.preventDefault();

      let currentPos = parseInt(sliderElem.getAttribute("data-pos"));

      if (currentPos < totalSlides && currentPos > 0) {
        newPos = currentPos - 1;
      }

      // let newDirection = newPos > currentPos ? "right" : "left";
      // let currentDirection = newPos < currentPos ? "right" : "left";

      // indicatorElem.classList.remove(`slider__indicator--${currentDirection}`);
      // indicatorElem.classList.add(`slider__indicator--${newDirection}`);
      sliderElem.setAttribute("data-pos", newPos);
    });
  }

  //About Slider
  $(".gallery-slider").on("init", function() {
    smooth.resize();
  });
  if ($(".gallery-slider").length > 0) {
    $(".gallery-slider").slick({
      arrows: true,
      infinite: false,
      cssEase: "ease-in-out",
      lazyLoad: "progressive",
      dots: false,
      fade: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: $(".custom-prev"),
      nextArrow: $(".custom-next")
    });
  }

  //Spotlight Slider
  $(".spotlight-slider").on("init", function() {
    smooth.resize();
  });
  if ($(".spotlight-slider").length > 0) {
    $(".spotlight-slider").slick({
      arrows: true,
      infinite: false,
      cssEase: "ease-in-out",
      lazyLoad: "progressive",
      dots: false,
      fade: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: $(".custom-prev"),
      nextArrow: $(".custom-next")
    });
  }

  //GALLERY
  if ($(".portfolioContainer").length > 0) {
    var $container = $(".portfolioContainer");
    $container.isotope({
      filter: "*",
      itemSelector: ".grid-item",
      layoutMode: "masonry",
      percentPosition: true,
      masonry: {
        // use element for option
        columnWidth: ".grid-sizer",
        gutter: 24
        // horizontalOrder: true
      },
      sortBy: "clickedFirst",
      getSortData: {
        clickedFirst: function(itemElem) {
          var $item = $(itemElem);
          // expanded first, otherwise use index
          return $item.hasClass("is-expanded") ? -1 : $item.index();
        }
      }
    });
    smooth.resize();

    var $items = $container.find(".grid-item");
    $container
      .addClass("is-showing-items")
      .isotope("revealItemElements", $items);

    $container.on("click", ".grid-item", function() {
      // change size of item by toggling is-expanded class
      var $this = $(this);
      // toggle other expanded
      if (!$this.hasClass("is-expanded")) {
        $container.find(".is-expanded").removeClass("is-expanded");
      }
      $this.toggleClass("is-expanded");
      // update sort data, sort, and layout
      smooth.resize();
      $container.isotope("updateSortData").isotope();
      var div = document.querySelector(".full-gallery");
      var offset = div.offsetTop;
      smooth.scrollTo(offset);
    });

    $(".portfolioFilter a").click(function(el) {
      $container.find(".is-expanded").removeClass("is-expanded");
      $(".portfolioFilter .current").removeClass("current");
      $(this).addClass("current");

      var selector = $(this).attr("data-filter");
      $container.isotope({
        filter: selector
      });
      smooth.resize();
      return false;
    });
  }

  $(".toggleVideo").on("click", function() {
    $(this)
      .closest(".video-wide")
      .toggleClass("playing");
    $(this).text(function(i, text) {
      return text === "DIM THE LIGHTS"
        ? "RAISE THE LIGHTS"
        : "DIM THE LIGHTS";
    });
  });

  //FORMS
  if ($("form").length > 0) {
    $('input:not([type="checkbox"]), textarea').focus(function() {
      $(this)
        .parents(".gfield")
        .addClass("focused");
    });

    if ($("#input_4_7").length > 0) {
      $("#input_4_7")
        .parents(".gfield")
        .addClass("focused");
      $("#input_4_7").prop("readonly", true);
    }

    if ($('input[type="file"]').length > 0) {
      $('input[type="file"]').each(function() {
        var $input = $(this);

        $input.on("change", function(e) {
          var fileName = "";

          if (this.files && this.files.length > 1)
            fileName = (
              this.getAttribute("data-multiple-caption") || ""
            ).replace("{count}", this.files.length);
          else if (e.target.value) fileName = e.target.value.split("\\").pop();

          if (fileName) {
            $(this).attr("data-filename", fileName);
          }
        });

        // Firefox bug fix
        // $input
        // .on( 'focus', function(){ $input.addClass( 'has-focus' ); })
        // .on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
      });
    }

    $('input:not([type="checkbox"]), textarea').blur(function() {
      var inputValue = $(this).val();
      if (inputValue == "") {
        $(this)
          .parents(".gfield")
          .removeClass("focused");
      }
    });
  }

  $(".off-canvas").on("opened.zf.offcanvas", function(e) {
    $(".hamburger").toggleClass("is-active");
  });
  $(".off-canvas").on("closed.zf.offcanvas", function(e) {
    $(".hamburger").toggleClass("is-active");
  });

  $(".tabs").on("change.zf.tabs", function(e) {
    smooth.resize();
  });

  //Slugify function
  function slugify(string) {
    const a = "àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœṕŕßśșțùúüûǘẃẍÿź·/_,:;";
    const b = "aaaaaaaaceeeeghiiiimnnnoooooprssstuuuuuwxyz------";
    const p = new RegExp(a.split("").join("|"), "g");
    return string
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/&/g, "-and-") // Replace & with ‘and’
      .replace(/[^\w\-]+/g, "") // Remove all non-word characters
      .replace(/\-\-+/g, "-") // Replace multiple - with single -
      .replace(/^-+/, "") // Trim - from start of text
      .replace(/-+$/, ""); // Trim - from end of text
  }
});

(function($) {
  /**
   * Copyright 2012, Digital Fusion
   * Licensed under the MIT license.
   * http://teamdf.com/jquery-plugins/license/
   *
   * @author Sam Sehnert
   * @desc A small plugin that checks whether elements are within
   *     the user visible viewport of a web browser.
   *     only accounts for vertical position, not horizontal.
   */

  $.fn.visible = function(partial) {
    var $t = $(this),
      $w = $(window),
      viewTop = $w.scrollTop(),
      viewBottom = viewTop + $w.height(),
      _top = $t.offset().top,
      _bottom = _top + $t.height(),
      compareTop = partial === true ? _bottom : _top,
      compareBottom = partial === true ? _top : _bottom;

    return compareBottom <= viewBottom && compareTop >= viewTop;
  };
})(jQuery);
